import React from 'react';
import * as PropTypes from 'prop-types';

import EmptyState from '@components/shared/EmptyState';

const ReviewsEmptyState = ({ size, caption, title }) => (
  <EmptyState
    size={size}
    caption={caption}
    img="/images/write-img.svg"
    title={title}
  />
);

ReviewsEmptyState.defaultProps = {
  caption:
    'Add your review to products, supplements or recipes to help others find the best solutions',
  title: `You haven't added any reviews yet`
};

ReviewsEmptyState.propTypes = {
  caption: PropTypes.string,
  title: PropTypes.string,
  size: PropTypes.string
};

export default ReviewsEmptyState;
